// extracted by mini-css-extract-plugin
export default {"screenshot":"styles_screenshot__NEoPs"};